import { render, staticRenderFns } from "./SimpleCropper.vue?vue&type=template&id=2f7cd056"
import script from "./SimpleCropper.vue?vue&type=script&lang=js"
export * from "./SimpleCropper.vue?vue&type=script&lang=js"
import style0 from "./SimpleCropper.vue?vue&type=style&index=0&id=2f7cd056&prod&scopd=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports